/**
 * @flow
 * @author: Pavan
 */

const styles = {
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    zIndex: 100,
    userSelect: 'none'
  },
  content: {
    userSelect: 'none',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'none',
    border: 'none'
  },
  phoneIcon: {
    height: '17px'
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/FormHomePage/styles.js